import { defineFeature } from "../core/composition/define-feature.js";
import { deriveCdnPriority } from "../behaviors/derive-cdn-priority.js";
import { setupFailoverMonitor } from "../behaviors/setup-failover-monitor.js";
//#region src/playback/features/multi-cdn.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [deriveCdnPriority, setupFailoverMonitor];
/** The config defaults the feature contributes. */
const defaultConfig = {};
/** The state values the feature seeds. */
const initialState = {};
/**
* Plays sources served from several CDNs (redundant streams): keeps every track type on one CDN, and fails over to the
* next when a CDN fails, returning to it once its cooldown lapses. Single-CDN sources pass through unchanged.
*/
const multiCdnFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, defaultConfig, initialState, multiCdnFeature };
